import { configureStore } from '@reduxjs/toolkit';
import { createReduxEnhancer } from '@sentry/react';

import { pointmanPhoneCallSlice } from '_lib/callPop/features/PointmanPhoneCall/PointmanPhoneCall.slice';
import { DEBUG } from '_lib/global/config';

const sentryReduxEnhancer = createReduxEnhancer({});

// Import slices from ALL application features here!
import { companySlice } from '../callPop/common/CompanyPane/Company.slice';
import { poolBrainPhoneCallSlice } from '../callPop/features/PoolBrainPhoneCall/PoolBrainPhoneCall.slice';
import { stApiPhoneCallSlice } from '../callPop/features/StApiPhoneCall/StApiPhoneCall.slice';
import { stCapacityPhoneCallSlice } from '../callPop/features/StCapacityPhoneCall/StCapacityPhoneCall.slice';
import { stPortalPhoneCallSlice } from '../callPop/features/StPortalPhoneCall/StPortalPhoneCall.slice';

import { listenerMiddleware } from './listenerMiddleware';

const rootReducer = {
  companySlice: companySlice.reducer,
  stApiPhoneCallSlice: stApiPhoneCallSlice.reducer,
  stCapacityPhoneCallSlice: stCapacityPhoneCallSlice.reducer,
  stPortalPhoneCallSlice: stPortalPhoneCallSlice.reducer,
  poolBrainPhoneCallSlice: poolBrainPhoneCallSlice.reducer,
  pointmanPhoneCallSlice: pointmanPhoneCallSlice.reducer
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: DEBUG,
  middleware: (getDefaultMiddleWare) => getDefaultMiddleWare().prepend(listenerMiddleware.middleware),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer)
});

// From https://react-redux.js.org/using-react-redux/usage-with-typescript#define-root-state-and-dispatch-types
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {phoneCall: PhoneCallState}
export type AppDispatch = typeof store.dispatch;

// Used to initialize store during testing
export const setupStore = (preloadedState?: RootState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
};
